import { FC, PropsWithChildren, Children, cloneElement, useRef, useContext, isValidElement, ReactElement } from 'react';

import { TableContext } from '@hh.ru/magritte-ui-table/context';
import { useTableVirtualizer } from '@hh.ru/magritte-ui-table/useTableVirtualizer';

import styles from './table.less';

export const TableBody: FC<PropsWithChildren<{ 'data-qa'?: string }>> = ({
    'data-qa': dataQa = 'table-body',
    children,
}) => {
    const ref = useRef(null);
    const childArray = Children.toArray(children).filter<ReactElement>((e): e is ReactElement => isValidElement(e));
    const { fixedSize } = useContext(TableContext);

    const virtualizer = useTableVirtualizer({
        count: childArray.length,
        isScrollContainer: !!fixedSize,
        tableBodyRef: ref,
    });
    const items = virtualizer.getVirtualItems();

    const [paddingTop, paddingBottom] =
        items.length > 0
            ? [
                  Math.max(0, items[0].start - virtualizer.options.scrollMargin),
                  Math.max(
                      0,
                      virtualizer.getTotalSize() - (items[items.length - 1].end - virtualizer.options.scrollMargin)
                  ),
              ]
            : [0, 0];

    return (
        <tbody ref={ref} className={styles.body} data-qa={dataQa}>
            {paddingTop > 0 && <tr style={{ height: paddingTop }}></tr>}
            {virtualizer.getVirtualItems().map((virtualItem) => {
                return cloneElement(childArray[virtualItem.index], {
                    key: virtualItem.key,
                    'data-index': virtualItem.index,
                    ref: virtualItem.measureElement,
                    measure: virtualItem.measureElement,
                });
            })}
            {paddingBottom > 0 && <tr style={{ height: paddingBottom }}></tr>}
        </tbody>
    );
};
